// The theme only disables carousel arrows after a scroll event, so a carousel whose items all fit
// (e.g. three recently viewed products) keeps showing a "next" arrow that does nothing.
// Hide both arrows whenever the carousel has nothing to scroll.

const watched = new WeakSet();

function watch(carousel) {
  if (watched.has(carousel) || !carousel.id) return;

  const controls = [...document.querySelectorAll(`[aria-controls="${carousel.id}"]`)].filter((element) =>
    ['CAROUSEL-PREV-BUTTON', 'CAROUSEL-NEXT-BUTTON'].includes(element.tagName)
  );
  if (controls.length === 0) return;

  watched.add(carousel);

  const update = () => {
    const fits = !carousel.isScrollable;
    controls.forEach((control) => control.toggleAttribute('hidden', fits));
  };

  new ResizeObserver(update).observe(carousel);
  [...carousel.children].forEach((cell) => new ResizeObserver(update).observe(cell));
  update();
}

let scheduled = false;

function scan() {
  scheduled = false;
  document.querySelectorAll('scroll-carousel').forEach(watch);
}

customElements.whenDefined('scroll-carousel').then(() => {
  scan();

  // Recently viewed products are fetched and inserted after load, so look for new carousels too.
  new MutationObserver(() => {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(scan);
  }).observe(document.body, { childList: true, subtree: true });
});
